import { createSlice } from "@reduxjs/toolkit";
import fetchResource from "../../utils/fetch-wrapper";

export const propertySlice = createSlice({
  name: "auth",
  initialState: {
    error: null,
    success: null,
    loading: false,
    properties: [],
  },
  reducers: {
    propertyStart: (state) => {
      state.loading = true;
      state.auth = false;
      state.properties = [];
    },
    propertySuccess: (state, { payload }) => {
      state.properties = payload;
      state.loading = false;
      state.success = true;
    },
    propertyFailed: (state, { payload }) => {
      state.properties = [];
      state.error = payload;
      state.loading = false;
    },
  },
});

export const {
  propertyStart,
  propertySuccess,
  propertyFailed,
} = propertySlice.actions;

const propertyFetch = () => {
  return fetchResource("property", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const propertyFetchThunk = () => async (dispatch) => {
  dispatch(propertyStart());
  propertyFetch()
    .then((reponse) => {
      console.log(reponse, "property thunk response");
      dispatch(propertySuccess(reponse));
    })
    .catch((err) => {
      console.log(err);
      dispatch(propertyFailed(err.toString()));
    });
};

export const propertyUpdateThunk = (payload, status) => async (
  dispatch,
  getState
) => {
  const data = { ...payload, status };
  const token = getState().auth.auth.token;
  fetchResource(`property/${payload._id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: data,
  })
    .then((reponse) => {
      console.log(reponse, "property update thunk response");
      dispatch(propertyFetchThunk());
    })
    .catch((err) => {
      console.log(err);
    });
};

export default propertySlice.reducer;
